module.exports = __webpack_public_path__ + "static/media/blyant.fd4ca8b5.m4a";